<div class="common-popup-container history-view-wrapper" *ngIf="true">
    <div class="d-flex align-items-center justify-content-between">
        <div class="d-flex align-items-center" *ngIf="false">
            <img src="assets/images/product_item_icon.jpg" alt="">
            <span class="title mb-0 ml-1">#{{invoiceId}}</span>
        </div>
        <span class="title mb-0">Invoice History</span>
        <img src="assets/images/new-set/thin-cancel.svg" class="cancel-icon" alt="" (click)="closePopup()">
    </div>



       <div class="my-input-group mt-2" >
        <label>Bookings</label>
        <div class="d-flex align-items-center"> 
           <span class="highlight-badge new-badge-container ml-1" *ngFor="let item of bookingNo | slice:0:5; let i = index">
    <!-- Show first 5 items -->
    <ng-container >
        #{{ item }}<span *ngIf="i < 4 && i < bookingNo.length - 1"></span>
    </ng-container>
    <!-- Show +N if more than 5 items -->
</span>

<span *ngIf="bookingNo.length > 5">
        +{{ bookingNo.length - 5 }}
    </span>
        </div>
    </div> 
    <div class="sticky-container mt-4">
        <ul class="journey-container">
            <li class="step-item history-step" *ngFor="let item of historyList">
                <ng-container *ngIf="getHistoryUI(item) as ui">

                    <!-- Icon -->
                    <img [src]="ui.icon" class="step-icon" alt="">

                    <div class="step-details ml-3">

                        <!-- Title section -->
                        <ng-container *ngIf="ui.isBadge; else normalTitle">
                            <span class="highlight-badge">
                                <img src="assets/images/new-set/pdf-icon.svg" alt="">
                                {{ ui.title }}
                            </span>
                        </ng-container>

                        <ng-template #normalTitle>
                            <p class="step-name ml-0" [ngClass]="ui.titleClass">
                                {{ ui.title }}
                            </p>
                        </ng-template>

                        <!-- Description -->
                        <p *ngIf="item.comment" class="description mt-2">
                            {{ item.comment }}
                        </p>

                        <!-- User + Date -->
                        <div class="user-details mt-2">
                            <div class="d-flex align-items-center">
                                <span class="name ml-1">
{{ item.updatedBy
    ? (item.updatedBy.length > 20
        ? (item.updatedBy | slice:0:20) + '...'
        : item.updatedBy)
    : 'U'
}}                                </span>
                            </div>

                            <span class="uploaded-date mb-0 ml-1">
                                on {{ item.updatedOn | date: 'dd MMM yyyy' }}
                            </span>
                        </div>

                    </div>

                </ng-container>
            </li>

        </ul>
    </div>
</div>


<div class="loader-overlay" *ngIf="uploadHistroyloading">
    <div class="loader-container">
        <img src="assets/images/reload.svg" alt="">
        <span>{{'COMMON.LBL_LOADER' | translate}}</span>
    </div>
</div>